import React, {Component} from 'react';
import {
    ContentMainStyled,
    ContentSizeStyled
} from "../../CommonAccess/LoginScreen/styled";
import TextFieldDefault
    from "../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";
import {Box, Button, MenuItem, Typography} from "@material-ui/core";
import MessageUtil from "../../../Utils/MessageUtil";
import {ButtonDelete, ContentRewardStyled} from "./styled";
import ModalComponent from "../../../Components/Modal/ModalComponent";
import TableCampaignMetaComponent
    from "./components/TableCampaignMetaComponent";
import RadioComponent from "../../../Components/RadioComponent/RadioComponent";
import TitleSectionComponent from "./components/TitleSectionComponent";
import CompanyService from "../../../Services/CompanyService";
import FixSelectComponent from "../../../Components/FixSelect/FixSelect";
import {CampaingMetaContext} from "../../../Contexts/CampaignMetaContext";

class FormCampaignMetaScreen extends Component {
    static contextType = CampaingMetaContext;

    constructor(props) {
        super(props);

        this.state = {
            isOpenClientsModal: false,
            radioClientPercent: null,
            companies: null,
            clientUuids: null,
        };
        this.companyService = new CompanyService();
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.formEdit === prevProps.formEdit) {
            return;
        }
        this.setFormEdit();
    }

    setFormEdit() {

        const response = this.props.formEdit;


        if (!response) return;

        const uuid = response?.uuid;
        const company_uuid = response.company?.uuid || "";
        const clientUuids = [response.client?.uuid].filter(Boolean); // Transforma o UUID do cliente em array
        const top_percent = response?.top_percent;
        const goal_title = response?.goal_title;


        const period = response.targets?.[0]?.period;
        const goal_type = response.targets?.[0]?.goal_type;
        const goal_value = Number(response.targets?.[0]?.goal_value ?? 0);
        const reward_type = response.targets?.[0]?.reward_type;
        const reward_points = response.targets?.[0]?.reward_points;


        const title = response.targets?.[0]?.award?.title ?? undefined;
        const description = response.targets?.[0]?.award?.description ?? undefined;
        const rules = response.targets?.[0]?.award?.rules ?? undefined;
        const amount = response.targets?.[0]?.award?.amount ?? undefined;

        this.setState({
            uuid,
            company_uuid,
            clientUuids,
            period,
            goal_type,
            goal_value,
            goal_title,
            reward_type,
            reward_points,
            title,
            description,
            rules,
            amount,
            top_percent,
        });
    }

    async load() {
        try {
            const companyResponse = await this.companyService.getByMatrix();

            this.setState({
                companies: companyResponse.data.data,
            });

        } catch (e) {
            throw e;
        }
    }

    handleChange(event) {
        const {name, value} = event.target;
        console.log(name, value);
        if (name === 'goal_value') {
            if (value < 0 || value > 100) {
                this.context.parent.setState({
                    messagens: MessageUtil.make({
                        title: 'Atenção',
                        body: 'Os valores aceitos devem estrar entre 0 e 100',
                    }),
                });
                return;
            }
        }

        this.setState({[name]: value});
    }

    handlerSubmit = () => {
        this.props.doCreate(this.state);
    }

    makeCompanies() {
        let itens = [];
        this.state?.companies?.forEach(function (value, index) {
            itens.push(
                <MenuItem key={index.uuid}
                          value={value.uuid}>{value.fantasy_name}</MenuItem>
            );
        })

        return itens;
    }


    controllerClientsModal = (action) => {
        this.setState({
            isOpenClientsModal: action,
        });
    }

    setClientsFromModal = (clients) => {
        this.setState({
            isOpenClientsModal: false,
            clientUuids: clients,
        })
    }

    showButtonDeleteAlter = () => {
        if (!this.props.formEdit) {
            return false;
        }

        if (this.isDisabled === false) {
            return false;
        }

        if (this.props.formEdit.status === 'draft') {
            return true;
        }

        return false;
    }


    isDisabled = () => {
        if (!this.props?.formEdit?.status) {
            return false;
        }
        return this.props?.formEdit?.status !== 'draft'
    }

    statusToHuman() {
        const statusMap = {
            draft: {
                title: 'Status atual: Rascunho',
                description: 'Nesse status a meta ainda pode ser alterada ou excluída.',
            },
            published: {
                title: 'Status atual: Publicada',
                description: 'Meta não pode mais ser alterada ou excluída.',
            },
            closed: {
                title: 'Status atual: Fechada',
                description: 'Meta não pode mais ser alterada ou excluída.',
            },
        };

        const currentStatus = this.props?.formEdit?.status;
        return statusMap[currentStatus] || false;
    }


    render() {
        return (
            <>
                <ContentMainStyled>
                    <ContentSizeStyled>
                        {this.statusToHuman() &&
                            <>
                                <TitleSectionComponent
                                    title={this.statusToHuman().title}
                                    subtitle={this.statusToHuman().description}/>
                                <SpacerComponent height={30}/>
                            </>
                        }
                        <TitleSectionComponent title={'Identificação'}
                                               subtitle={'Dê um nome para esta meta para identificá-la mais facilmente na listagem'}/>
                        <TextFieldDefault label={'Nome *'}
                                          name={'goal_title'}
                                          type={'text'}
                                          value={this.state.goal_title}
                                          onChange={(event) => this.handleChange(event)}
                                          erros={this.props.erros}
                                          disabled={this.isDisabled()}/>

                        <SpacerComponent height={30}/>

                        <TitleSectionComponent title={'Meta'}
                                               subtitle={'Nesta seção, serão configurados os requisitos e como a meta será atingida.'}/>
                        <FixSelectComponent>
                            <TextFieldDefault label={'Tipo *'}
                                              name={'goal_type'}
                                              select={true}
                                              value={this.state.goal_type}
                                              onChange={(event) => this.handleChange(event)}
                                              erros={this.props.erros}
                                              disabled={this.isDisabled()}>
                                <MenuItem key={'percentage'}
                                          value={'percentage'}>Porcentagem</MenuItem>
                                <MenuItem key={'points'}
                                          value={'points'}>Pontos</MenuItem>
                            </TextFieldDefault>
                        </FixSelectComponent>
                        <Box display={'flex'}
                             justifyContent={'center'}>
                            <FixSelectComponent>
                                <TextFieldDefault label={'Periodo *'}
                                                  name={'period'}
                                                  select={true}
                                                  value={this.state.period}
                                                  onChange={(event) => this.handleChange(event)}
                                                  erros={this.props.erros}
                                                  disabled={this.isDisabled()}>
                                    <MenuItem key={'weekly'} value={'weekly'}>Meta
                                        semanal</MenuItem>
                                    <MenuItem key={'monthly'} value={'monthly'}>Meta
                                        mensal</MenuItem>
                                </TextFieldDefault>
                            </FixSelectComponent>
                            <SpacerComponent width={20}/>
                            <TextFieldDefault label={'Fator *'}
                                              name={'goal_value'}
                                              type={'number'}
                                              value={this.state.goal_value}
                                              onChange={(event) => this.handleChange(event)}
                                              erros={this.props.erros}
                                              disabled={this.isDisabled()}/>
                        </Box>

                        <SpacerComponent height={30}/>

                        <TitleSectionComponent title={'Premiação'}
                                               subtitle={'Nesta seção, você informará o tipo de premiação e definirá o prêmio, que poderá ser em pontos ou prêmios físicos.'}/>
                        <FixSelectComponent>
                            <TextFieldDefault label={'Tipo de premiação*'}
                                              name={'reward_type'}
                                              select={true}
                                              value={this.state.reward_type}
                                              onChange={(event) => this.handleChange(event)}
                                              erros={this.props.erros}
                                              disabled={this.isDisabled()}>
                                <MenuItem key={'points'} value={'points'}>Ganha
                                    mais
                                    pontos</MenuItem>
                                <MenuItem key={'award'} value={'award'}>Ganhar
                                    prêmio</MenuItem>
                            </TextFieldDefault>
                        </FixSelectComponent>
                        {this.state.reward_type === 'points' &&
                            <TextFieldDefault label={'Pontos a receber *'}
                                              name={'reward_points'}
                                              type={'number'}
                                              value={this.state.reward_points}
                                              onChange={(event) => this.handleChange(event)}
                                              erros={this.props.erros}
                                              disabled={this.isDisabled()}/>
                        }
                        {this.state.reward_type === 'award' &&
                            <>
                                <TextFieldDefault label={'Nome do prêmio *'}
                                                  name={'title'}
                                                  value={this.state.title}
                                                  onChange={(event) => this.handleChange(event)}
                                                  erros={this.props.erros}
                                                  disabled={this.isDisabled()}/>
                                <TextFieldDefault label={'Regras'}
                                                  name={'rules'}
                                                  value={this.state.rules}
                                                  type={'number'}
                                                  multiline={true}
                                                  onChange={(event) => this.handleChange(event)}
                                                  erros={this.props.erros}
                                                  rows={5}
                                                  disabled={this.isDisabled()}/>
                                <SpacerComponent height={20}/>
                                <TextFieldDefault label={'Descrição *'}
                                                  name={'description'}
                                                  value={this.state.description}
                                                  onChange={(event) => this.handleChange(event)}
                                                  erros={this.props.erros}
                                                  multiline={true}
                                                  rows={5}
                                                  disabled={this.isDisabled()}/>
                                <TextFieldDefault label={'Quantido estoque *'}
                                                  name={'amount'}
                                                  type={'number'}
                                                  value={this.state.amount}
                                                  onChange={(event) => this.handleChange(event)}
                                                  erros={this.props.erros}
                                                  disabled={this.isDisabled()}
                                                  disabled={this.isDisabled()}/>
                            </>
                        }

                        <SpacerComponent height={30}/>

                        <TitleSectionComponent title={'Empresa'}
                                               subtitle={'Nesta seção, você deve informar a empresa que estará participando da campanha. Isso afetará a sua lista de clientes.'}/>
                        <FixSelectComponent>
                            <TextFieldDefault
                                label={'Escolha a empresa para essa meta *'}
                                name={'company_uuid'}
                                select={true}
                                value={this.state.company_uuid}
                                onChange={(event) => this.handleChange(event)}
                                erros={this.props.erros}
                                disabled={this.isDisabled()}>
                                {this.makeCompanies()}
                            </TextFieldDefault>
                        </FixSelectComponent>

                        <SpacerComponent height={30}/>

                        <TitleSectionComponent title={'Clientes'}
                                               subtitle={'Nesta seção, você informará os clientes participantes da meta, podendo escolher, de forma simples, uma porcentagem dos clientes que mais compram ou selecionar manualmente um a um e aplicar a meta individualmente.'}/>
                        <TextFieldDefault
                            label={'Forma de selecionar os clientes *'}
                            name={'type_client'}
                            select={true}
                            value={this.state.type_client}
                            onChange={(event) => this.handleChange(event)}
                            erros={this.props.erros}
                            disabled={this.isDisabled() || !this.state.company_uuid}>
                            <MenuItem key={'1'} value={1}>Porcentagem</MenuItem>
                            <MenuItem key={'2'} value={2}>Selecionar
                                manualmente</MenuItem>
                        </TextFieldDefault>

                        {this.state.type_client === 1 &&
                            <>
                                <Typography variant={'subtitle1'}>Escolha abaixo
                                    o
                                    percentual de clientes participantes da
                                    meta.</Typography>
                                <SpacerComponent height={20}/>
                                <RadioComponent name={'10'} value={10}
                                                checked={this.state.top_percent === 10}
                                                onChange={() =>
                                                    this.setState({
                                                        top_percent: 10,
                                                    })
                                                }
                                                label={'10%'}/>
                                <RadioComponent name={'15'} value={15}
                                                checked={this.state.top_percent === 15}
                                                onChange={() => this.setState({
                                                    top_percent: 15
                                                })}
                                                label={'15%'}/>
                                <RadioComponent name={'20'} value={20}
                                                checked={this.state.top_percent === 20}
                                                onChange={() =>
                                                    this.setState({
                                                        top_percent: 20,
                                                    })
                                                }
                                                label={'20%'}/>
                            </>
                        }

                        {this.state.type_client === 2 &&
                            <ContentRewardStyled
                                isVisible={true}>
                                <Button variant={'text'}
                                        color={'primary'}
                                        size={"large"}
                                        fullWidth={true}
                                        onClick={() => this.controllerClientsModal(true)}>
                                    Selecionar Clientes
                                </Button>
                            </ContentRewardStyled>
                        }

                        <SpacerComponent height={50}/>

                        {!this.props.formEdit &&
                            <Box display="flex" justifyContent="center">
                                <Button variant={'contained'}
                                        color={'primary'}
                                        size={"large"}
                                        fullWidth={true}
                                        onClick={this.handlerSubmit}>
                                    Registrar Campanha Meta
                                </Button>
                            </Box>
                        }


                        {this.showButtonDeleteAlter() &&

                            <Box display="flex" justifyContent="center">
                                <Button variant={'contained'}
                                        color={'primary'}
                                        size={"large"}
                                        fullWidth={true}
                                        onClick={this.handlerSubmit}>
                                    Alterar Campanha Meta
                                </Button>
                            </Box>

                        }


                        <SpacerComponent height={20}/>
                        {this.showButtonDeleteAlter() &&
                            <Box display="flex" justifyContent="center">
                                <ButtonDelete variant={'contained'}
                                              size={"large"}
                                              fullWidth={true}
                                              onClick={() => this.props.doDelete(this.state.uuid)}>
                                    Deletar
                                </ButtonDelete>
                            </Box>
                        }
                    </ContentSizeStyled>
                </ContentMainStyled>
                <ModalComponent isOpen={this.state.isOpenClientsModal}
                                onClose={() => this.controllerClientsModal(false)}
                                title={'Selecione os cliente abaixo'}
                                fullWidth={true}
                                maxHeight={700}
                                withOverflowY={true}
                                zIndex={9999}>
                    <SpacerComponent height={40}/>
                    <TableCampaignMetaComponent
                        companyUuid={this.state.company_uuid}
                        setClientsFromModal={this.setClientsFromModal}
                        clientUuids={this.state.clientUuids}/>
                </ModalComponent>
            </>
        );
    }
}

export default FormCampaignMetaScreen;